import { useState } from "react"
import { SearchBar } from "../../components/generic/SearchBar"
import { HelpItems } from "../../constant/data"
import { Button } from "../../components/forms"
import { BsPlus } from "react-icons/bs";
import { FaPhoneAlt } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";


 
const Help=()=>{


    const [entered, setentered] =useState("")

    const onChange =((e:string)=>{


        setentered(e)
            })
        

    return(<div className="flex flex-col justify-center items-center">
<div className="w-full min-h-[20vh] py-4 bg-faintBlue flex justify-center items-center">
<div className="flex justify-center flex-col items-center gap-3 py-4">

    <p className="text-xs text-textbg font-medium">FAQs</p>
    <p className="text-xl  text-blueGray font-bold ">
        Ask us anything
    </p>
    <p className="text-xs text-textbg font-light">Have any questions? We're here to assist you.</p>
    <SearchBar placeholder="Search" onchange={onChange} value={entered} />

    
</div>
</div>

<div  className="w-[50%] bg-white rounded-[20px] border border-gray-300 p-4 m-4" >

    { 
        HelpItems.map((i:any)=>(<div className="p-2 border border-gray-200 rounded-[8px] my-2"> 
        <p className="text-xs text-textbg font-semibold flex justify-between">
            {i.title} <BsPlus size={20}/></p> 
           {/* { <p className="text-xs text-textbg font-light">
            You can log in to your account and change it from your Profile Edit Profile. Then go to the general tab to change your email.
        </p>} */}
        </div>))
    }
<div className="bg-faint p-3 flex justify-between  rounded-[8px] items-center">
    <div>
    <p className="text-xs text-textbg font-semibold">
Still have Questions?
        </p>
    <p className="text-xs text-textbg font-light">
    Can’t find the answer you’re looking for? Please chat to our friendly team.
        </p>
    </div>
<Button
            width={200}
            text="Get in touch"
            onBtnClick={()=>{}}
          />

</div>
<div className="w-full mt-2">
<p className="w-full text-center font-bold mb-2text-xs">Contact Us:</p>

<div className="flex justify-center items-center">
    <p className="text-xs text-textbg"><FaPhoneAlt className="inline mr-1"/> +234 8056 394 493</p>
    <p className="text-xs text-textbg"><MdOutlineEmail  className="inline ml-1"/> info@rwndengage.com</p>

</div>
    
</div>
</div>
    </div>)
}

export{Help}